import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatDate } from '../../utils';
import {
  findPersonEmail,
  findPersonPhoneNumber,
  getFullName,
} from '../Person/utils';
import { getUserRoles } from './utils';

const getTableData = (data, columns) => {
  const headers = columns
    .filter(({ id }) => id !== 'actions')
    .map(({ Header }) => Header);
  const rows = [];
  data.forEach((entry) => {
    const rolesData = getUserRoles(entry, entry?.id);
    const roles = rolesData
      ?.map(({ title, active }) => (active ? title : `${title} (inactive)`))
      .join('\n');
    const properties = columns?.[2]?.accessor(entry, true);
    rows.push([
      getFullName(entry),
      roles,
      properties,
      findPersonEmail(entry),
      findPersonPhoneNumber(entry),
      formatDate(entry.lastActivityTime) || 'Never',
      entry?.registered ? 'Yes' : 'No',
      entry?.hasActiveRoles ? 'Yes' : 'No',
    ]);
  });
  return { headers, rows };
};

const GlobalPersonSearchExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default GlobalPersonSearchExport;
